<template>
  <div class="ux-footer-wrap">
    <div class="ux-footer">
      <div class="ux-footer-content">
        <p>&copy; 2019 Dhal Studio, All Rights Reserved</p>
        <p v-if="!loggedIn" class="push-right">
          <router-link :to="{path:'/login'}">Client Portal Login</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss" scoped>
.ux-footer-wrap {
  position: relative;
  margin-top: 50px;
}
.ux-footer {
  background: #000;
}
.ux-footer-content {
  padding: 2rem 0;
  color: rgb(87, 87, 87);
  p:first-child {
    border-bottom: 1px solid rgba(white, 0.2);
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    margin-left: 2rem;
    margin-right: 2rem;
  }
  p {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 2em;
    font-weight: 300;
  }
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: rgb(107, 141, 150);
    text-decoration: none;
  }
}
</style>
